import { createContext, useEffect } from "react";
import { useDispatchApp, useSelectorApp } from "../lib/redux";
import {
  startListenerUserAdvertiserID,
  verifyUserAdvertiserID,
} from "../actions/auth";
import { useNavigate } from "react-router-dom";
import { startGetBrandInformation } from "../actions/adsCampaigns";
import { SimpleAlert } from "../components/Alerts/Alerts";
import { ALERT_ICON_TYPE_INFO, OWNER_ROLE } from "../utils/constants";
import { ALERT_CHANGE_ADVERTISER_TITLE } from "../i18n/keysTranslations";
import { useTranslationApp } from "../lib/i18next";
import { getDefaultAppRoute } from "../utils/advertisersDemo";

export const AdvertiserContext = createContext();

export const AdvertiserProvider = ({ children }) => {
  const navigate = useNavigate();
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const { user } = useSelectorApp((state) => state.auth);

  const onChangeAdvertiserID = async (advertiserID) => {
    // No verificar cambios de advertiser para usuarios owner
    if (user?.role === OWNER_ROLE) {
      return;
    }

    const ok = await dispatch(verifyUserAdvertiserID(advertiserID));
    if (!ok) {
      navigate(
        getDefaultAppRoute({
          advertiserID,
          agencyID: user?.agencyID,
        })
      );
      const brandInformation = await dispatch(startGetBrandInformation());
      if (brandInformation.ok) {
        const businessName = brandInformation?.data?.businessName;
        SimpleAlert({
          title: t(ALERT_CHANGE_ADVERTISER_TITLE, { businessName }),
          icon: ALERT_ICON_TYPE_INFO,
        });
      }
    }
  };

  useEffect(() => {
    if (!user?.role) return;

    // No iniciar el listener para usuarios owner
    if (user?.role === OWNER_ROLE) {
      return;
    }
    dispatch(
      startListenerUserAdvertiserID({
        onCallback: onChangeAdvertiserID,
      })
    );
    //eslint-disable-next-line
  }, [user?.role]);

  return (
    <AdvertiserContext.Provider value={{ onChangeAdvertiserID }}>
      {children}
    </AdvertiserContext.Provider>
  );
};
